(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["background-video-v2"] && !Shopify.designMode) return;
  try {
    
  class BackgroundVideoV2 {
    constructor(element) {
      this.element = element;
      this.videoType = element.dataset.videoType;
      this.autoplay = element.dataset.autoplay === 'true';
      this.loop = element.dataset.loop === 'true';
      this.muted = element.dataset.muted === 'true';
      this.enableMobile = element.dataset.enableMobile === 'true';
      this.video = null;
      this.player = null;
      this.isPlaying = false;

      this.init();
    }

    init() {
      const isMobile = window.innerWidth < 768;

      // Disable video on mobile if setting is false
      if (isMobile && !this.enableMobile) {
        this.showPosterOnly();
        return;
      }

      if (this.videoType === 'hosted') {
        this.initHostedVideo();
      } else if (this.videoType === 'youtube') {
        this.initYouTube();
      } else if (this.videoType === 'vimeo') {
        this.initVimeo();
      }
    }

    initHostedVideo() {
      this.video = this.element.querySelector('.bg-video-v2__video');
      if (!this.video) return;

      // Ensure best mobile behavior
      this.video.setAttribute('playsinline', '');
      this.video.setAttribute('webkit-playsinline', '');
      this.video.playsInline = true;

      // Apply configured attributes
      try {
        this.video.muted = this.muted;
        this.video.loop = this.loop;
        this.video.preload = 'auto';
        if (this.autoplay) this.video.autoplay = true;
      } catch (e) {
        // Some video elements may be implemented differently in Liquid; ignore attribute errors
      }

      const playPauseBtn = this.element.querySelector('[data-video-control="play-pause"]');
      if (playPauseBtn) {
        playPauseBtn.addEventListener('click', () => this.togglePlayPause());
      }

      this.video.addEventListener('play', () => this.updatePlayPauseButton(true));
      this.video.addEventListener('pause', () => this.updatePlayPauseButton(false));

      // Update aspect ratio after metadata loads so auto height mode matches the native video
      this.video.addEventListener('loadedmetadata', () => {
        if (this.video.videoWidth && this.video.videoHeight) {
          const ratio = this.video.videoWidth / this.video.videoHeight;
          this.element.style.setProperty('--aspect-ratio', ratio);
        }
      });

      // Handle autoplay (may be blocked) and fallback to poster
      if (this.autoplay) {
        const playPromise = this.video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            // Autoplay prevented; show poster/fallback and keep controls available
            this.showPosterOnly();
            const btn = this.element.querySelector('[data-video-control="play-pause"]');
            if (btn) btn.style.display = 'none';
          });
        }
      }
    }

    initYouTube() {
      const youtubeId = this.element.dataset.youtubeId;
      if (!youtubeId) return;

      // Load YouTube IFrame API
      if (!window.YT) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubeIframeAPIReady = () => this.createYouTubePlayer(youtubeId);
      } else {
        this.createYouTubePlayer(youtubeId);
      }
    }

    createYouTubePlayer(videoId) {
      const playerId = this.element.querySelector('.bg-video-v2__youtube').id;

      this.player = new YT.Player(playerId, {
        videoId: videoId,
        playerVars: {
          autoplay: this.autoplay ? 1 : 0,
          loop: this.loop ? 1 : 0,
          mute: this.muted ? 1 : 0,
          controls: 0,
          showinfo: 0,
          modestbranding: 1,
          playsinline: 1,
          rel: 0,
          playlist: this.loop ? videoId : undefined,
        },
        events: {
          onReady: (event) => {
            if (this.autoplay) event.target.playVideo();
          },
        },
      });
    }

    initVimeo() {
      const vimeoId = this.element.dataset.vimeoId;
      if (!vimeoId) return;

      const playerId = this.element.querySelector('.bg-video-v2__vimeo').id;
      const iframe = document.createElement('iframe');

      iframe.src = `https://player.vimeo.com/video/${vimeoId}?autoplay=${this.autoplay ? 1 : 0}&loop=${
        this.loop ? 1 : 0
      }&muted=${this.muted ? 1 : 0}&background=1`;
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'autoplay; fullscreen');
      iframe.setAttribute('allowfullscreen', '');

      document.getElementById(playerId).appendChild(iframe);
    }

    togglePlayPause() {
      if (!this.video) return;

      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    }

    updatePlayPauseButton(isPlaying) {
      const btn = this.element.querySelector('[data-video-control="play-pause"]');
      if (!btn) return;

      const playIcon = btn.querySelector('.bg-video-v2__play-icon');
      const pauseIcon = btn.querySelector('.bg-video-v2__pause-icon');

      if (isPlaying) {
        playIcon.style.display = 'none';
        pauseIcon.style.display = 'block';
      } else {
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
      }
    }

    showPosterOnly() {
      const videoWrapper = this.element.querySelector('.bg-video-v2__video-wrapper');
      if (!videoWrapper) return;

      const video = videoWrapper.querySelector('video, iframe');
      const poster = videoWrapper.querySelector('.bg-video-v2__poster');

      if (video) {
        try {
          video.pause();
        } catch (e) {}
        video.style.display = 'none';
      }

      if (poster) {
        poster.style.display = 'block';
      } else {
        // fallback: dim video area to indicate poster/fallback
        videoWrapper.style.backgroundColor = '#000';
      }

      const playBtn = this.element.querySelector('[data-video-control="play-pause"]');
      if (playBtn) playBtn.style.display = 'none';
    }
  }

  // Initialize all background video sections
  document.addEventListener('DOMContentLoaded', () => {
    const videoSections = document.querySelectorAll('.bg-video-v2');
    videoSections.forEach((section) => new BackgroundVideoV2(section));
  });

  } catch(e) { console.error(e); }
})();
})();
